<template>
  <div>
    <div class="mb-3">
      <div class="headline primary--text mb-1">Real-time Performance</div>
      <div class="subtitle">
        Updated at:
        <template v-if="updatedAt">{{ updatedAt | DateFormat('DD/MM/YYYY HH:mm') }}</template>
        <template v-else>-</template>
      </div>
    </div>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :pagination="{ rowsPerPage: -1 }"
      :total-items="items.length"
      class="elevation-1"
      hide-actions
    >
      <template #items="{ item }">
        <td>{{ item.channel }}</td>
        <td class="text-xs-right">{{ item.total_case_count || 0 }}</td>
        <td class="text-xs-right">{{ item.pending_case_count || 0 }}</td>
        <td class="text-xs-right">{{ item.sl || 0 | decimalFormat(2) }}%</td>
        <!-- <td class="text-xs-right">
          {{ handleGetMaxPendingDelayed(item) }}
        </td>
        <td class="text-xs-right">{{ item.nps_avg || 0 | decimalFormat(2) }}%</td>
        <td class="text-xs-right">{{ item.osat_top_box || 0 | decimalFormat(2) }}%</td>
        <td class="text-xs-right">{{ item.osat_top_2box || 0 | decimalFormat(2) }}%</td> -->
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ticket3AgentManagementApi from '@/api/ticket3/agent-management'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { PAGE_GROUP } from '@/constants/page.js'

export default {
  filters: {
    minutes(value) {
      const seconds = value % 60
      const minutes = Math.floor(value / 60)
      const padZero = (value) => value.toString().padStart(2, '0')
      return `${padZero(minutes)}:${padZero(seconds)}`
    }
  },
  data() {
    return {
      updatedAt: undefined,
      items: [],
      headers: [
        { text: 'Channel', value: 'channel', sortable: false },
        { text: 'Total Received', value: 'total_case_count', sortable: false, align: 'right' },
        { text: 'Pending', value: 'pending_case_count', sortable: false, align: 'right' },
        { text: '%SLA', value: 'sl', sortable: false, align: 'right' }
        // {
        //   text: 'Max pending delayed',
        //   sortable: false,
        //   align: 'right'
        // },
        // { text: '%NPS', value: 'nps_avg', sortable: false, align: 'right' },
        // { text: '%OSAT TOP BOX', value: 'osat_top_box', sortable: false, align: 'right' },
        // { text: '%OSAT TOP 2 BOX', value: 'osat_top_2box', sortable: false, align: 'right' }
      ],
      loading: true,
      fetchInterval: undefined
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    isCIMBWealthPage() {
      return this.selectedBot.page_group === PAGE_GROUP.CIMB_WEALTH
    }
  },
  async mounted() {
    this.loading = true
    await this.handleGetRealtimePerformance()
    // fetch every 2 minutes
    this.fetchInterval = setInterval(async () => {
      if (this.loading) return
      await this.handleGetRealtimePerformance()
    }, 1000 * 60 * 2)
    this.loading = false
  },
  beforeDestroy() {
    clearInterval(this.fetchInterval)
  },
  methods: {
    handleGetMaxPendingDelayed(item) {
      return `${moment(item.max_load_start_count).format('HH:mm')} -  ${moment(
        item.max_load_end_count
      ).format('HH:mm')}`
    },
    async handleGetRealtimePerformance() {
      try {
        const updatedAt = moment()
        const response = await ticket3AgentManagementApi.getRealTimePerformance({
          params: {
            page_id: this.selectedBot.pageid,
            date: updatedAt.format('YYYY-MM-DD')
          }
        })
        if (response.data.data) {
          let data = response.data.data
          const filteredItems = data.filter(
            (item) =>
              item.channel === 'all' ||
              this.socialChannelOptions.findIndex(
                (socialChannelOption) => socialChannelOption.fullValueForUse === item.channel
              ) !== -1
          )
          if (this.isCIMBWealthPage) {
            this.items = filteredItems.filter((item) => !['facebook'].includes(item.channel))
          } else {
            this.items = filteredItems
          }

          this.updatedAt = updatedAt.format()
        } else {
          return {
            status: true,
            data: []
          }
        }
      } catch (error) {
        console.error(error)
        // this.$swal.fire({ type: 'error', text: error.toString() })
        return {
          status: false,
          data: []
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/overview/RealtimePerformance.vue